// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GetPlusButton_OnuMe {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #676767;
  outline: none;
  border: none;
  cursor: pointer;
  background: var(--white-background);
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 16px;
  border: 2px solid #cacaca;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GetPlusButton/GetPlusButton.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".GetPlusButton {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #676767;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background: var(--white-background);\n  font-weight: 600;\n  padding: 5px 10px;\n  border-radius: 16px;\n  border: 2px solid #cacaca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GetPlusButton": `GetPlusButton_OnuMe`
};
export default ___CSS_LOADER_EXPORT___;
